import React, { useContext } from 'react';
// components
import AdultsDropdown from '../components/AdultsDropdown';
import KidsDropdown from '../components/KidsDropdown';
import CheckIn from '../components/CheckIn';
import CheckOut from '../components/CheckOut';
import { RoomContext } from '../context/RoomContext';
import { useTranslation } from 'react-i18next';

const BookForm = () => {
  const { handleClick } = useContext(RoomContext);
  const { t } = useTranslation();

  const handleBooking = (e) => {
    e.preventDefault();
    handleClick(e);  
    window.open('https://www.booking.com/hotel/pl/copernicus-house-krakow3.pl.html', '_blank');
  };

  return (
    <form className='h-[300px] w-full lg:h-[70px]'>
      <div className='flex flex-col w-full h-full lg:flex-row'>
        <div className='flex-1 border-r'>
          <CheckIn />
        </div>
        <div className='flex-1 border-r'>
          <CheckOut />
        </div>
        <div className='flex-1 border-r'>
          <AdultsDropdown />
        </div>
        <div className='flex-1 border-r'>
          <KidsDropdown />
        </div>
        <button
          onClick={handleBooking}
          type='button' 
          className='btn btn-primary'
        >
          {t('Rezerwuj')}
        </button>
      </div>
    </form>
  );
};

export default BookForm;
